import styled from "styled-components";
import {styledByDevice} from "../../themes/architecture/styled-by-device";
import {HOME_PAGE, LIVE_CASINO_PAGE, MOVE_TOP} from "../../themes/css-global-classes";
import { CssRule } from "../../themes/architecture/css-helpers/css-rule";

export const PCBox = styled.div`
  display: block;
  width: 100%;
  padding-left:  ${props => props.theme.layout.wrapper.padding.pc};
  padding-right: ${props => props.theme.layout.wrapper.padding.pc};
  
  // This is for CLS purpose, we want to make sure there is no 'jump' of the footer when lazy loaded swipers loads
  padding-bottom: 300px;
  
  .${HOME_PAGE} &.${MOVE_TOP}{
    margin-top: -14rem;
  }

  .${LIVE_CASINO_PAGE} & {
      padding-left: 10rem;
      padding-right: 10rem;
      padding-top: 20px;
      @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        &.${MOVE_TOP} {
          padding-left: 3rem;
          padding-right: 3rem;
        }
      }
  }
`;

export const MobileBox = styled.div`
  display: block;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  
  // This is for CLS purpose, we want to make sure there is no 'jump' of the footer when lazy loaded swipers loads
  padding-bottom: 300px;

  .${HOME_PAGE} & {
    &.${MOVE_TOP} {
      margin-top: -10rem;
    }

      ${CssRule.For.mobile.embededHybrid.build()} & {
          &.${MOVE_TOP} {
            margin-top: 1rem;
            margin-bottom: 0;
          }
      }
  }

  .${LIVE_CASINO_PAGE} & {
    padding-top: 10px;
  }
`;
export const LayoutWrapperDefaultBox = styledByDevice(PCBox, MobileBox);